// ROUTING
export const isPortalContext =
  (_state, _getters, _rootState, rootGetters) => (route) => {
    const client = rootGetters['shared/getClient']
    return client === 'client1contributor' && route?.meta?.isPortal
  }

export const isPublicProfileContext =
  (_state, _getters, _rootState, rootGetters) => (route) => {
    const client = rootGetters['shared/getClient']
    return client === 'client1contributor' && !route?.meta?.isPortal
  }

// ORGANISATIONS
export function getOrganisations(state) {
  return state.organisations
}

export function getOrganisation(state) {
  return state.organisation
}

export function getOrganisationId(state) {
  return state.organisation?.id || null
}

export function getOrganisationName(state) {
  return state.organisation?.title
}

// DASHBOARD/STATS
export function getPostCounter(state) {
  return state.postCounter
}

export function canPost(_state, getters) {
  // const currentMonth = new Date().getMonth(); // 0 = January, 11 = December
  // if (currentMonth === 11 || currentMonth === 0) {
  //   return false;
  // }
  const counter = getters.getPostCounter
  return counter?.count < counter?.cap
}

export function getStudentReach(state) {
  return state.studentReach
}

export function getSchoolsCount(state) {
  return state.schoolsCount
}

export function getSchools(state) {
  return state.schools
}

export function getRegions(state) {
  return state.regions
}

export function getMailouts(state) {
  return state.mailouts
}

export function getPostCategories(state) {
  return state.postCategories || {}
}

export function getPostCategoriesCount(state) {
  return state.postCategoriesCount
}

export function getTopPosts(state) {
  return state.topPosts
}

export function getOrganisationActivityPostShares(state) {
  return state.organisationActivity?.postShares
}

export function getOrganisationActivityPostReach(state) {
  return state.organisationActivity?.postReach
}

export function getOrganisationActivityPostCategories(state) {
  return state.organisationActivity?.postCategories || {}
}

export function getOrganisationActivityPostCategoriesCount(state) {
  return state.organisationActivity?.postCategoriesCount
}

export function getOrganisationActivityPostsMailedCount(state) {
  return state.organisationActivity?.postsMailedCount
}

export function getOrganisationActivityNewsletterReach(state) {
  return state.organisationActivity?.newsletterReach
}

// POSTS
export function getPosts(state) {
  return state.posts
}

export function getPostsStats(state) {
  return state.postsStats
}

// CONNECTIONS
export function getConnectionsCounter(state) {
  return state.connectionsCounter
}

export function canAddConnection(_state, getters, _rootState, rootGetters) {
  const counter = getters.getConnectionsCounter
  const isUnderCap = counter?.count < counter?.cap

  const isContributorAdminConnectionsOnly =
    rootGetters['shared/isContributorAdminConnectionsOnly']
  if (isContributorAdminConnectionsOnly) {
    const hasConnectionBeenCreated = getters.hasConnections
    return !hasConnectionBeenCreated && isUnderCap
  }

  return isUnderCap
}

export function getConnections(state) {
  return state.connections
}

export function hasConnections(_state, getters) {
  return !!getters.getConnections.length
}

export function getConnectionsWithStats(state) {
  return state.connectionsWithStats
}

export function getConnectionsPagination(state) {
  return state.connectionsPagination
}

export function getConnectionsImpressionsCount(state) {
  return state.connectionsImpressionsCount
}

export function getConnectionsViewsCount(state) {
  return state.connectionsViewsCount
}

export function getConnectionsContactedCount(state) {
  return state.connectionsContactedCount
}

// ACCOUNTS
export function getAccounts(state) {
  return state.accounts
}

export const getAccount = (_state, getters) => (id) => {
  return getters.getAccounts.find((account) => account.id === id) || null
}

// PUBLIC PROFILE
export function getOrganisationProfile(state) {
  return state.organisationProfile
}

export function getOrganisationProfileId(_state, getters) {
  return getters.getOrganisationProfile?.id || null
}

export function getOrganisationProfilePosts(state) {
  return state.organisationProfilePosts
}

export function getOrganisationProfilePostsPagination(state) {
  return state.organisationProfilePostsPagination
}

export function getOrganisationProfileConnections(state) {
  return state.organisationProfileConnections
}

export function hasProfileConnections(_state, getters) {
  return getters.getOrganisationProfileConnections?.length
}
